__turbopack_context__.v({
  "eyebrow": "ParagraphClientLogos-module__Uu4ZDW__eyebrow",
  "grid": "ParagraphClientLogos-module__Uu4ZDW__grid",
  "item": "ParagraphClientLogos-module__Uu4ZDW__item",
  "logo": "ParagraphClientLogos-module__Uu4ZDW__logo",
  "section": "ParagraphClientLogos-module__Uu4ZDW__section",
});
